module.exports = __webpack_public_path__ + "img/bazar.64f51f4.svg";